import { SEARCH_BOX_ACTION } from "../../constants/searchBoxAction";
import { TrackingLabel } from "../TrackingLabel";

export class SearchBoxAction extends TrackingLabel<string> {
  readonly name: string = "san_SearchBoxAction";
  private readonly _value: string = "";
  private _isTrackable: boolean = false;
  private isTracked: boolean = false;
  constructor(value: string, isTrackable: boolean) {
    super();
    this._value = value;
    this._isTrackable = isTrackable;
  }
  override get data(): { [p: string]: string } {
    const data = super.data;
    if (this.value === SEARCH_BOX_ACTION.CHAR) {
      this.isTracked = true;
    }
    return data;
  }

  get value(): string {
    return this._value;
  }

  /*             */
  setIsTracked(isTracked: boolean) {
    this.isTracked = isTracked;
  }
  setIsTrackable(isTrackable: boolean) {
    this._isTrackable = isTrackable;
  }
  isTrackable(): boolean {
    return this._isTrackable && !this.isTracked;
  }
}
export const tlSearchBoxActionClick = new SearchBoxAction(SEARCH_BOX_ACTION.CLICK, true);
export const tlSearchBoxActionCharacter = new SearchBoxAction(SEARCH_BOX_ACTION.CHAR, true);
